import { useEffect, useState } from "react";
import { createClient } from "pexels";

const client_id: any = process.env.REACT_APP_PEXELS_CLIENT_ID
const client = createClient(client_id);

export const usePixabaySearchVideos = () => {
  const [query, setQuery] = useState({q:"",index:0});
  const [loading, setLoading] = useState(false);
  const [videoData, setVideoData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [loadmore,setLoadMore] = useState(true);
  const [dLength,setDlength] = useState(0);
  
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);

    const fetchVideo = async () => {
      const per_page = 20;
    
      if (query.q === '') {
        const searchQuery = 'popular';
        const data: any = await client.videos.search({ query: searchQuery, per_page, page });
        const filteredData = data.videos.filter((item: any) => !item.video_files[1].link.includes('progressive_redirect'));
    
        setVideoData(filteredData);
        setDlength(filteredData.length || 0);
      } else {
        const data: any = await client.videos.search({ query: query.q, per_page, page });
        const filteredData = data.videos.filter((item: any) => !item.video_files[1].link.includes('progressive_redirect'));
    
        setVideoData(filteredData);
        setDlength(filteredData.length || 0);
      }
    };
    
    fetchVideo()
      return () => {
        controller.abort();
      };
  }, [query]);

  const search = (query: any) => {
    setQuery({q:query.q, index:query.index});
  };

  // const fetchMoreData = async () => {

  //   const per_page = 20;
    
  //   if(query.q === ''){
  //     const data: any = await client.videos.search({ query: 'popular', page : page + 1, per_page })
  //     const d = videoData
  //     console.log(data) 
  //     setVideoData([...d, ...data.videos])
  //   }else{
  //     const data: any = await client.videos.search({ query: query.q, page: page + 1, per_page })
  //     const d = videoData
  //     setVideoData([...d, ...data.videos])
  //   }
    
  //   setPage(page + 1);
  // };

  // const fetchMoreData = async () => {
  //   const per_page = 20;
  
  //   if (query.q === '') {
  //     const data: any = await client.videos.search({ query: 'popular', page: page + 1, per_page });
  //     const d = videoData;
      
  //     data.videos.forEach((item: any) => {
  //       if(item.video_files[1].link.includes('progressive_redirect')){
  //         return
  //       }else{
          
  //         setVideoData([...d,...data.videos])
  //         setPage(page + 1);
  //       }
  //     })
  //     //setVideoData([...d, ...data.videos]);
  //     //setPage(page + 1); // Increment page when searching for popular videos
  //   } else {
  //     const data: any = await client.videos.search({ query: query.q, page: page + 1, per_page });
  //     const d = videoData;
  //     setVideoData([...d, ...data.videos]);
  //     setPage(page + 1); // Increment page for other searches as well
  //   }
  // };

  const fetchMoreData = async () => {
    setLoadMore(true)
    const per_page = 20;
    const nextPage = page + 1;
  
    if (query.q === '') {
      const data: any = await client.videos.search({ query: 'popular', page: nextPage, per_page });
      const d = data.videos.filter((item: any) => !item.video_files[1].link.includes('progressive_redirect'));
    
      setVideoData([...videoData, ...d]);
      setPage(page + 1);
    } else {
      const data: any = await client.videos.search({ query: query.q, page: nextPage, per_page });
      const d = data.videos.filter((item: any) => !item.video_files[1].link.includes('progressive_redirect'));
  
      setVideoData([...videoData, ...d]);
      setPage(page + 1);
    }

    setLoadMore(false)
  };
  
  

  return { search, videoData, loading, fetchMoreData,loadmore,setLoadMore,setPage };
};